module.exports = __webpack_public_path__ + "img/pessoa.8353bd26.png";